export const plansTranslations = {
  pt: {
    pro: {
      name: 'Pro',
      features: [
        '2 páginas de links',
        'Links ilimitados',
        'Métricas salvas por 30 dias',
        'Personalização completa de design',
        'Analytics avançado com gráficos',
        'Remover marca Hub Links',
        'Suporte por WhatsApp',
        'Temas premium exclusivos',
      ],
    },
    premium: {
      name: 'Premium',
      features: [
        '5 páginas de links',
        'Links ilimitados',
        'Métricas salvas por 365 dias (1 ano)',
        'Personalização completa de design',
        'Analytics avançado com gráficos',
        'Remover marca Hub Links',
        'Suporte por WhatsApp',
        'Integrações avançadas',
        'Relatórios personalizados',
      ],
    },
  },
  en: {
    pro: {
      name: 'Pro',
      features: [
        '2 link pages',
        'Unlimited links',
        'Metrics saved for 30 days',
        'Complete design customization',
        'Advanced analytics with charts',
        'Remove Hub Links branding',
        'WhatsApp support',
        'Exclusive premium themes',
      ],
    },
    premium: {
      name: 'Premium',
      features: [
        '5 link pages',
        'Unlimited links',
        'Metrics saved for 365 days (1 year)',
        'Complete design customization',
        'Advanced analytics with charts',
        'Remove Hub Links branding',
        'WhatsApp support',
        'Advanced integrations',
        'Custom reports',
      ],
    },
  },
} as const;
